import React from 'react';
import { Link } from 'react-router-dom';

const newsItems = [
  {
    img: 'images/cnbc_500.jpeg',
    url: 'https://www.cnbctv18.com/education/ascend-capital-bags-50-crore-in-series-a-plans-to-hire-500-as-it-targets-300-crore-aum-19099661.htm',
  },
  {
    img: 'images/dainik_bhaskar_500.jpeg',
    url: null,
  },
  {
    img: 'images/your_story_50_crore.jpeg',
    url: 'https://yourstory.com/2024/02/funding-ev-financing-startup-ascend-capital-rs-50-crore',
  },
  {
    img: 'images/money_control_ascend_capital.jpg',
    url: 'https://www.moneycontrol.com/news/business/ascend-capital-plans-to-raise-rs-500-crore-in-next-18-months-10988321.html/amp',
  },
];

class News extends React.Component {
  constructor(props) {
    super(props);
    this.state = { current: 0 };
    this.timer = null;
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      this.setState(prev => ({ current: (prev.current + 1) % newsItems.length }));
    }, 3500);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  go(index) {
    clearInterval(this.timer);
    this.setState({ current: (index + newsItems.length) % newsItems.length });
    this.timer = setInterval(() => {
      this.setState(prev => ({ current: (prev.current + 1) % newsItems.length }));
    }, 3500);
  }

  render() {
    const { current } = this.state;
    const item = newsItems[current];

    return (
      <div className="news-section-dark" style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
        <div className="section-title text-center">
          <h2>In The News</h2>
        </div>

        <div style={{ position: 'relative', width: '100%', maxWidth: 672, margin: '0 auto', padding: '0 16px', boxSizing: 'border-box' }}>
          {/* Card */}
          <div
            className="news_card news-card-dark"
            style={{ cursor: item.url ? 'pointer' : 'default', margin: '0 auto', width: '100%' }}
            onClick={() => item.url && window.open(item.url, '_blank')}
          >
            <div className="news_card_img">
              <img src={item.img} alt="" style={{ width: '100%', display: 'block' }} />
            </div>
          </div>

          {/* Prev button */}
          <button
            onClick={(e) => { e.stopPropagation(); this.go(current - 1); }}
            style={{
              position: 'absolute',
              top: '50%',
              left: 24,
              transform: 'translateY(-50%)',
              background: 'rgba(146,90,148,0.85)',
              border: 'none',
              borderRadius: '50%',
              width: 38,
              height: 38,
              color: '#fff',
              fontSize: 18,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 2,
            }}
          >‹</button>

          {/* Next button */}
          <button
            onClick={(e) => { e.stopPropagation(); this.go(current + 1); }}
            style={{
              position: 'absolute',
              top: '50%',
              right: 24,
              transform: 'translateY(-50%)',
              background: 'rgba(146,90,148,0.85)',
              border: 'none',
              borderRadius: '50%',
              width: 38,
              height: 38,
              color: '#fff',
              fontSize: 18,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 2,
            }}
          >›</button>
        </div>

        {/* Dots */}
        <div style={{ display: 'flex', gap: 8, marginTop: 18 }}>
          {newsItems.map((_, i) => (
            <button
              key={i}
              onClick={() => this.go(i)}
              style={{
                width: i === current ? 22 : 8,
                height: 8,
                borderRadius: 4,
                background: i === current ? '#c77dcc' : 'rgba(199,125,204,0.3)',
                border: 'none',
                cursor: 'pointer',
                padding: 0,
                transition: 'all 0.3s ease',
              }}
            />
          ))}
        </div>

        <Link
          to="/press-release"
          className="view-more-link"
          style={{ fontWeight: 'bold', alignSelf: 'center', marginTop: 20, fontSize: 20, cursor: 'pointer' }}
        >
          View More
        </Link>
      </div>
    );
  }
}

export default News;



// WEBPACK FOOTER //
// ./src/components/News.js